mediator = require 'mediator'
Tooltip = require 'components/common/tooltip'
{ WHO_WORKSPACES } = require 'lib/who_helper'

MagicWhoRecommendationType = ({ recommendation }) ->
  return null unless mediator.activeWorkspace in WHO_WORKSPACES

  recommendationTypeIntervention = recommendation.getIn(
    ['templateData', 'conclusions', 'sections', 'recommendationTypeIntervention'], Immutable.Map())

  recommendationType = recommendationTypeIntervention.get('selectedOption')
  return null if not recommendation or recommendationType in ['no_strength', 'not_set']
  options = recommendationTypeIntervention
    .get('options', Immutable.List())
    .concat(recommendationTypeIntervention.get('customOptions', Immutable.List()))

  recommendationText = options.find (option) ->
    option.get('value') is recommendationType

  return null unless recommendationText

  return <div className="recommendation-type">
    <Tooltip>
      <span title={recommendationText.get('tooltip', '')} className="recommendation-type__label #{recommendationType}">
        {recommendationText.get('text', '')}
      </span>
    </Tooltip>
  </div>

module.exports = MagicWhoRecommendationType
